import { id } from './hardware-models';

export const hardwareModels = {
  id,
};
